import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.number.constructor";
import _objectSpread from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.function.name";
import _regenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import _asyncToGenerator from "E:/smartlink/front/lianhe/ctruck-lock-front/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import store from '@/store';
import { buildMenus, subApplicationMenus } from '@/api/system/menu';
var routerConfigs = [];
var subMenus = [];
function getLocalMenus() {
  return _getLocalMenus.apply(this, arguments);
}
function _getLocalMenus() {
  _getLocalMenus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var modulesFiles;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          // subMenus = []
          // try {
          //     const info = await subApplicationMenus()
          //     if (info.code === 200) {
          //         subMenus = JSON.parse(info.data)
          //     }
          //     console.log('=======subApplicationMenus===========>', subMenus)
          // } catch (e) {
          //     subMenus = []
          // }
          // routerConfigs = [].concat(subMenus)
          routerConfigs = [];
          modulesFiles = require.context('./routerFileConfig', true, /\.js$/);
          modulesFiles.keys().reduce(function (modules, modulePath) {
            var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
            var value = modulesFiles(modulePath);
            routerConfigs.push(value[moduleName]);
          }, {});
        case 1:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _getLocalMenus.apply(this, arguments);
}
var _getSubMenusTitle = function getSubMenusTitle(path) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (list.length === 0) {
    list = JSON.parse(JSON.stringify(subMenus));
  }
  list.forEach(function (item) {
    if (item.path === path) {
      title = item.meta.title;
    } else {
      if (!title && item.children && item.children.length) {
        title = _getSubMenusTitle(path, item.children, title);
      }
    }
  });
  return title;
};
export { _getSubMenusTitle as getSubMenusTitle };
export var filterMatchMenu = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mlist) {
    var roles, codes, codeStr, codeList, serviceMeneList, menus;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return getLocalMenus();
        case 1:
          // console.log('=======subApplicationMenus=====end======>')
          roles = store.getters.roles;
          codes = roles.map(function (item) {
            return item.elemCodes;
          });
          codeStr = codes.join(',');
          codeList = codeStr.split(',');
          serviceMeneList = filterServiceMene(codeList, mlist, [], 1);
          menus = filterMenuList(serviceMeneList, [], 'Layout'); // 菜单排序
          menus = menuOrderNumber(menus);
          console.log('%c 菜单数据重构完毕', 'color: #43bb88;font-size:24px;font-weight: bold;text-decoration: underline;');
          console.log(menus);
          subMenus = [].concat(menus);
          return _context.a(2, menus);
      }
    }, _callee);
  }));
  return function filterMatchMenu(_x) {
    return _ref.apply(this, arguments);
  };
}();

// 过滤服务器权限菜单
function filterServiceMene(codes, list, rlist) {
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  // 判定是数组并且有数据
  if (list instanceof Array && list.length) {
    list.forEach(function (item) {
      if (item.elemCode.indexOf('-') !== -1) {
        return;
      }
      var flag = codes.some(function (o) {
        return o === item.elemCode;
      });
      var mo = menuExit(item.elemCode, routerConfigs, null);
      if (flag && mo) {
        mo.level = level;
        mo.orderNum = item.orderNum;
        mo.name = item.elemName;
        mo.meta.title = item.elemName;
        mo.children = filterServiceMene(codes, item.subPageElemRelationDtoList, [], level + 1);
        rlist.push(mo);
      }
    });
  }
  return rlist;
}
// 判定当前菜单树中是否存在本地菜单，无则过滤
function menuExit(code, list) {
  var mo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  list.forEach(function (item) {
    if (mo) {
      return;
    } else {
      if (item.elemCode === code) {
        mo = item;
        return;
      }
      if (item.children) {
        mo = menuExit(code, item.children, mo);
      }
    }
  });
  return mo;
}
// 将服务端权限菜单根据前端配置的菜单进行过滤
function filterMenuList(serviceMeneList, list, componentName) {
  // 判定是数组并且有数据
  if (serviceMeneList instanceof Array && serviceMeneList.length) {
    serviceMeneList.forEach(function (item) {
      // const obj = getLocalMenuList(routerConfigs, item.elemCode, null)
      // if (!obj) return;
      // console.log('item.elemName===>' + item.visible)
      var mo = {
        alwaysShow: item.children.length === 1 ? false : true,
        elemCode: item.elemCode,
        hidden: item.hidden,
        name: item.name,
        path: item.path,
        meta: {
          icon: item.meta.icon,
          noCache: item.meta.noCache,
          title: item.meta.title,
          level: item.level
        },
        orderNum: item.orderNum,
        sort: item.sort,
        children: []
      };
      // 菜单和目录的筛分
      if (item.children && item.children.length) {
        if (item.children[0]['elemCode'] && item.children[0]['elemCode'].indexOf('-') !== -1) {
          mo = _objectSpread(_objectSpread({}, mo), {}, {
            component: item.component
          });
        } else {
          mo = _objectSpread(_objectSpread({}, mo), {}, {
            component: componentName,
            redirect: 'noredirect'
          });
        }
      } else {
        mo = _objectSpread(_objectSpread({}, mo), {}, {
          component: item.component
        });
      }
      if (componentName !== 'Layout') {
        delete mo.alwaysShow;
      }
      if (item.children && item.children.length) {
        mo.children = filterMenuList(item.children, [], 'routerView/routerView');
      } else {
        delete mo.children;
      }
      list.push(mo);
    });
  }
  return list;
}
// 为了适应用户中心随意配置菜单层级，在本地配置的菜单中，捞取对应权限的配置 
function getLocalMenuList(list, elemCode) {
  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (list instanceof Array && list.length) {
    list.forEach(function (item) {
      if (item.elemCode === elemCode) {
        obj = item;
      } else {
        obj = getLocalMenuList(item.children, elemCode, obj);
      }
    });
  }
  return obj;
}

// 菜单排序：本地配置了 sort 的按 sort 升序排在最前，未配置的仍按 orderNum 升序（保持原有顺序）
function menuOrderNumber() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (list instanceof Array && list.length) {
    list.forEach(function (item) {
      if (item.children && item.children.length) {
        item.children = menuOrderNumber(item.children);
      }
    });
    list = list.sort(function (a, b) {
      var hasSortA = a.sort !== undefined && a.sort !== null;
      var hasSortB = b.sort !== undefined && b.sort !== null;
      if (hasSortA && hasSortB) {
        return Number(a.sort) - Number(b.sort);
      }
      if (hasSortA) return -1;
      if (hasSortB) return 1;
      return Number(a.orderNum) - Number(b.orderNum);
    });
  }
  return list;
}